import { AbstractResource } from "./AbstractResource";

export class Gateways extends AbstractResource {
    async getEncodings() {
        const { data } = await this.http.get(`/encoding`, {
            baseURL: process.env.VUE_APP_API_URL,
        });
        return data;
    }

    async getMetadatas() {
        const { data } = await this.http.get(`/gateways/metadata`);
        return data;
    }

    async getAllProxies() {
        const { data } = await this.http.get(`/proxies`);
        return data;
    }

    async getById(gatewayId) {
        const { data } = await this.http.get(`/gateways/${gatewayId}`);
        return data;
    }

    async getList() {
        const { data } = await this.http.get(`/gateways`);
        return data;
    }

    async remove(gatewayId) {
        const { data } = await this.http.delete(`/gateways/${gatewayId}`);
        return data;
    }

    async create(dto) {
        const { data } = await this.http.post(`/gateways`, dto);
        return data;
    }

    async update(gatewayId, dto) {
        const { data } = await this.http.put(`/gateways/${gatewayId}`, dto);
        return data;
    }

    async getInstructionsById(gatewayId) {
        const { data } = await this.http.get(`/gateways/${gatewayId}/instructions`);
        return data;
    }

    async getInstructions() {
        const { data } = await this.http.get(`/gateways/instructions`);
        return data;
    }

    async getInstructionsMetadata() {
        const { data } = await this.http.get(`/gateways/instructions/metadata`);
        return data;
    }

    async testSampleFile(gatewayId, instructions, file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('instructions', JSON.stringify(instructions));
        const { data } = await this.http.post(`/gateways/${gatewayId}/sample`, formData, {
            headers: {
                'Content-Type': `multipart/form-data`,
            }
        });
        return data;
    }

    async saveInstructions(gatewayId, dto) {
        const { data } = await this.http.put(`/gateways/${gatewayId}/instructions`, dto);
        return data;
    }
}